import { useNavigate, useLocation } from 'react-router-dom'
import { getLocaleFromPath, getScreenPath } from '@utils'

export const useCustomNavigate = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (path: string) => {
    const locale = getLocaleFromPath(pathname)
    const pathOnly = path.split('?')[0]
    const screen = getScreenPath(pathOnly.startsWith('/') ? pathOnly : `/${pathOnly}`)
    const nextPath = locale ? `/${locale}/${screen}` : `/${screen}`
    navigate(`${nextPath}${window.location.search}`, { replace: true })
  }
}
